import { ReactElement, useEffect, useRef } from 'react';
import { useGenerateHealthGraph } from '../../hooks/useGenerateHealthGraph';
import { GraphContainer, LegendContainer, LegendContent } from './styles';
import { Circle } from '~/pages/NewOverview/components/GraphTooltip/styles';
import { colorByHealthVariant, parseHealthVariantLabel } from '../../helpers';
import { HealthVariant } from '../UnitsInfo/types';
import { GetUnitHealthHistory } from 'pages/NewOverview/types';
import { colors } from 'styles/colors';
import { useTranslation } from 'react-i18next';

interface HealthGraphProps {
  data: GetUnitHealthHistory | undefined;
}

export function HealthGraph({
  data,
}: Readonly<HealthGraphProps>): ReactElement {
  const chartReference = useRef<HTMLDivElement>(null);

  const { renderHealthChart } = useGenerateHealthGraph(chartReference, false);

  useEffect(() => renderHealthChart(data), [data]);

  return (
    <>
      <GraphContainer>
        <div id="health-card" ref={chartReference} style={{ width: '100%', height: '100%' }} />
      </GraphContainer>
      <LegendGraph disabled={!data} />
    </>
  );
}

function LegendGraph({ disabled }: Readonly<{ disabled: boolean }>): ReactElement {
  return (
    <LegendContainer>
      {disabled ? (
        <Legend variant="no-data" />
      ) : (
        <>
          <Legend variant="healthy" />
          <Legend variant="alert" />
          <Legend variant="critical" />
          <Legend variant="inoperative" />
        </>
      )}
    </LegendContainer>
  );
}

function Legend({ variant }: Readonly<{ variant: HealthVariant | 'no-data' }>): ReactElement {
  const { t } = useTranslation();

  if (variant === 'no-data') {
    return (
      <LegendContent>
        <Circle color={colors.icon['disabled-300']} />
        <span>{t('semDados')}</span>
      </LegendContent>
    );
  }

  return (
    <LegendContent>
      <Circle color={colorByHealthVariant(variant)} />
      <span>{parseHealthVariantLabel(variant)}</span>
    </LegendContent>
  );
}
